<template>
  <div id="defaultQuestionnaires">
    <v-row>
      <v-col cols="12" md="11">
        <v-card class="pa-3">
          <v-card-title>
            <h4>{{$t($route.meta.breadcrumb[2].text)}}</h4>
          </v-card-title>
          <v-card-subtitle>
            <p>{{$t('tests.defaultTestMessage')}}</p>
          </v-card-subtitle>
          <v-card-text>
            <div v-if="loading">
              <v-progress-linear
                indeterminate
                :active="loading"
                color="primary"
              ></v-progress-linear>
              <p class="text-center">{{$t('general.loading')}}</p>
            </div>
            <v-form
              lazy-validation
              v-else
              ref="form"
              v-model="valid"
            >
              <v-row>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    outlined
                    dense
                    :items="countries"
                    item-text="name"
                    item-value="id"
                    :rules="rules.required"
                    v-model="item.country_id"
                  >
                    <template v-slot:label>
                      <span>{{$t('address.country')}}</span><span class="error--text">&nbsp;*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    outlined
                    dense
                    :items="sites"
                    item-text="name"
                    item-value="id"
                    multiple
                    chips
                    small-chips
                    :rules="rules.required"
                    :error-messages="errors.sites"
                    v-model="item.sites">
                    <template v-slot:prepend-item>
                      <v-list-item
                        ripple @mousedown.prevent
                        @click="toggleSites">
                        <v-list-item-action>
                          <v-icon :color="sites.length > 0 ? 'primary' : ''">
                            {{ iconSites }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ $t('general.selectAll')}}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"/>
                    </template>
                    <template v-slot:label>
                      <span>{{$t('general.sites')}}</span><span class="error--text">&nbsp;*</span>
                    </template>
                    <template v-slot:selection="data">
                      <v-chip
                        small
                        color="primary">
                        {{data.item.name}}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <v-list-item-avatar>
                        <v-icon>fas fa-map-marked-alt</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>
                          <span class="font-weight-black">{{data.item.name}}</span>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          ( {{data.item.address.street + ' #' + data.item.address.street_number + `, ${$t('address.zip')}: ` + data.item.address.zip_code}} )
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    outlined
                    dense
                    :items="unitTypes"
                    item-text="alias"
                    item-value="id"
                    multiple
                    chips
                    small-chips
                    :rules="rules.required"
                    v-model="item.unit_type"
                  >
                    <template v-slot:prepend-item>
                      <v-list-item
                        ripple @mousedown.prevent
                        @click="toggle">
                        <v-list-item-action>
                          <v-icon :color="unitTypes.length > 0 ? 'primary' : ''">
                            {{ icon }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ $t('general.selectAll')}}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"/>
                    </template>
                    <template v-slot:label>
                      <span>{{$t('general.unitType')}}</span><span class="error--text">&nbsp;*</span>
                    </template>
                    <template v-slot:selection="data">
                      <v-chip
                        small
                        color="primary">
                        {{data.item.alias}}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <span>{{$t('sites.typeQuestionnaire.title')}}</span><span class="error--text">&nbsp;* :</span>
                  <v-radio-group
                    hide-details="auto"
                    required
                    :rules="rules.required"
                    class="mt-1"
                    v-model="item.type"
                    row
                  >
                    <v-radio
                      class="mt-0"
                      color="primary"
                      v-for="types in questionnaireType"
                      :key="types.value"
                      :label="types.text"
                      :value="types.value"
                    />
                  </v-radio-group>
                </v-col>
                <v-col cols="12" md="6">
                  <span>{{$t('general.template')}}</span><span class="error--text">&nbsp;* :</span>
                  <v-radio-group
                    hide-details="auto"
                    required
                    :rules="rules.required"
                    class="mt-1"
                    v-model="item.templates"
                    row
                  >
                    <v-radio
                      class="mt-0"
                      color="primary"
                      v-for="template in templates"
                      :key="template.value"
                      :label="template.text"
                      :value="template.value"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-form>
              <v-row>
                <v-col cols="12">
                  <v-btn
                    :loading="loadButton"
                    :disabled="loadButton"
                    depressed
                    class="float-right"
                    @click="save"
                    color="primary">
                    {{$t('general.save')}}
                  </v-btn>
                   <v-btn
                    outlined
                    class="float-right mr-3"
                    @click="redirect"
                    color="primary">
                    {{$t('general.cancel')}}
                  </v-btn>
                </v-col>
              </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="11">
        <v-row class="pa-4" dense align="center" justify="center" v-if="loadingTemplate">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
          <span class="text-center primary--text ml-2">{{$t('general.loadingTemplate')}}</span>
        </v-row>
        <div v-if="!loadingTemplate && item.templates !== ''">
          <h4 class="mb-3">{{$t('sites.preview')}}</h4>
          <div v-for="(template, i) in templateQuestionnaire.sections" :key="i" class="mb-4">
            <v-row dense no-gutters align="center" class="pb-3">
              <v-col cols="2">
                <span><b>{{$t('general.section')}} {{template.position + 1}}: {{template.name}}</b></span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="5">
                <v-autocomplete
                  hide-details="auto"
                  outlined
                  dense
                  :items="unitTypes"
                  item-text="alias"
                  item-value="id"
                  multiple
                  chips
                  small-chip
                  :label="$t('sites.relationUnit')"
                  :rules="rules.required"
                  readonly
                  v-model="template.unit_type_id">
                  <template v-slot:selection="data">
                    <v-chip
                      small
                      color="primary">
                      {{data.item.alias}}
                    </v-chip>
                  </template>
                </v-autocomplete>
                </v-col>
              </v-row>
              <v-card class="pa-3" flat outlined>
                <v-data-table
                  :headers="headersQuestionnaire"
                  :items="template.questions"
                  hide-default-footer>
                  <template v-slot:item.is_critical="{ item }">
                    {{item.is_critical === true ? $t('notification.yes') : $t('notification.no')}}
                  </template>
                  <template v-slot:item.comment_required="{ item }">
                    {{item.comment_required === true ? $t('notification.yes') : $t('notification.no')}}
                  </template>
                </v-data-table>
              </v-card>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'defaultQuestionnaires',
  data () {
    return {
      loading: false,
      loadButton: false,
      templateDialog: false,
      valid: true,
      countries: [],
      sites: [],
      unitTypes: [],
      item: {
        country_id: 150,
        sites: [],
        templates: '',
        unit_type: [],
        type: ''
      },
      errors: {},
      customs: {},
      templateQuestionnaire: [],
      loadingTemplate: false
    }
  },
  computed: {
    rules () {
      return this.$validationRules()
    },
    templates () {
      let array = []
      for (let key in this.customs) {
        array.push({ value: `${key}`, text: `${this.customs[key]}` })
      }
      return array
    },
    unitTypesAll () {
      return this.item.unit_type.length === this.unitTypes.length
    },
    unitTypesSome () {
      return this.item.unit_type.length > 0 && !this.unitTypesAll
    },
    sitesAll () {
      return this.item.sites.length === this.sites.length
    },
    sitesSome () {
      return this.item.sites.length > 0 && !this.sitesAll
    },
    icon () {
      if (this.unitTypesAll) return 'mdi-close-box'
      if (this.unitTypesSome) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    iconSites () {
      if (this.sitesAll) return 'mdi-close-box'
      if (this.sitesSome) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    questionnaireType () {
      return [
        {
          text: this.$t('sites.typeQuestionnaire.security'),
          value: 'SECURITY'
        },
        {
          text: this.$t('sites.typeQuestionnaire.maintenance'),
          value: 'MAINTENANCE'
        },
        {
          text: this.$t('sites.typeQuestionnaire.log'),
          value: 'LOG'
        }
      ]
    },
    headersQuestionnaire () {
      return [
        {
          text: this.$t('sites.headers.questionTitle'),
          align: 'center',
          value: 'name',
          sortable: false
        },
        {
          text: this.$t('sites.headers.description'),
          align: 'center',
          value: 'description',
          sortable: false
        },
        {
          text: this.$t('tests.critic'),
          align: 'center',
          value: 'is_critical',
          sortable: false
        },
        {
          text: this.$t('sites.headers.comment'),
          align: 'center',
          value: 'comment_required',
          sortable: false
        }
      ]
    }
  },
  watch: {
    'item.sites' (val) {
      if (val.length > 0) this.errors = {}
    },
    'item.templates' (val) {
      if (val) {
        this.loadingTemplate = true
        this.$store.dispatch('tests/questionnaireDefault', {
          event: {
            context: this,
            type: val
          }
        })
      }
    }
  },
  created () {
    this.$store.dispatch('getCountry', {
      event: {
        context: this
      }
    })
    this.$store.dispatch('sites/get', {
      event: {
        context: this,
        item: {
          perPage:-1,
          page: 1
        }
      }
    })
    this.$store.dispatch('unitTypes/getAll', {
      event: {
        context: this
      }
    }),
    this.$store.dispatch('tests/customQuestionnaires', {
      event: {
        context: this
      }
    })
  },
  methods: {
    toggle () {
      this.$nextTick(() => {
        if (this.unitTypesAll) {
          this.item.unit_type = []
        } else {
          this.unitTypes.map(i => {
            this.item.unit_type.push(i.id)
          })
          // this.item.unit_type = this.unitTypes.slice()
        }
      })
    },
    toggleSites () {
      this.$nextTick(() => {
        if (this.sitesAll) {
          this.item.sites = []
        } else {
          this.sites.map(i => {
            this.item.sites.push(i.id)
          })
          // this.item.sites = this.sites.slice()
        }
      })
    },
    save () {
      if (this.$refs.form.validate()) {
        if (this.item.sites.length < 1) {
          this.errors = {sites: this.$t('validation.required')}
        } else {
          this.loadButton = true
          this.$store.dispatch('tests/defaultQuestionnaires', {
            event: {
              context: this,
              item: this.item
            }
          })
        }
      }
    },
    redirect () {
      this.$router.push('/checklists')
    }
  }
}
</script>